export default __webpack_public_path__ + "static/media/Padron_2000Open.c422fe9a.jpg";